/**
 * Displays results.
 */
import classnames from 'classnames';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import React, { PropTypes } from 'react';
import ButtonPrevious from './ButtonPrevious';
import ResultAllStrengths from './ResultAllStrengths';
import ResultHigh from './ResultHigh';
import ResultItem from './ResultItem';
import ResultLow from './ResultLow';
import ResultMedium from './ResultMedium';
import ResultNoStrengths from './ResultNoStrengths';
import ResultsOverlay from './ResultsOverlay';

function Result({
  answers,
  assessmentData,
  clearAssessmentResults,
  emailOverlay,
  emailResults,
  emailSent,
  previousStep,
  questions,
  readingListItems,
  resultUserEmail,
  setResult,
  toggleEmailOverlay,
}) {
  const highResults = [];
  const lowResults = [];
  const mediumResults = [];
  const {
    fieldAllStrengthsText,
    fieldAllStrengthsTitle,
    fieldGoodIntroText,
    fieldGoodResultsTitle,
    fieldLowIntroText,
    fieldLowResultsTitle,
    fieldMediumIntroText,
    fieldMediumResultsTitle,
    fieldNoStrengthsText,
    fieldNoStrengthsTitle,
  } = assessmentData[0];
  // Compile results arrays based on indicated choices.
  forEach(answers, (choice, entityId) => {
    const entity = find(questions, { id: entityId.toString() });
    const { fieldMediumResult, fieldHighResult, id } = entity;
    if (choice === 0) {
      // Low results deviated from the model of 1 question to 1 result, so we
      // have to compile a list
    } else if (choice <= 2) {
      mediumResults.push(
        <ResultItem
          innerHtml={fieldMediumResult}
          key={`medium-${id}`}
        />,
      );
    } else {
      highResults.push(
        <ResultItem
          innerHtml={fieldHighResult}
          key={`high-${id}`}
        />,
      );
    }
  });
  // @TODO: remove all of this nonsense and adjust the view to output raw
  // entity data for low items since they need to be compiled before being
  // rendered, unlike all of the other result data.
  if (readingListItems.length !== 0) {
    const lowResultString = readingListItems.map(article =>
      `<li>${article.fieldArticle}</li>`,
    ).join('');
    lowResults.push(
      <ResultItem
        innerHtml={`<h4>Articles to get you started</h4><ul>${lowResultString}</ul>`}
        key={'low-results-group'}
      />,
    );
  }
  const showNoStrengths = !highResults.length;
  const showAllStrengths = (!lowResults.length && !mediumResults.length);
  const showResults = 'Results are available for 45 minutes unless you close the browser or click "Clear Results".';
  return (
    <div
      key="results"
      className={classnames({
        results: true,
      })}
    >
      <h1>
        Your Results
      </h1>
      {emailOverlay &&
        <ResultsOverlay
          emailResults={emailResults}
          emailSent={emailSent}
          resultUserEmail={resultUserEmail}
          setResult={setResult}
          toggleEmailOverlay={toggleEmailOverlay}
        />
      }
      <div
        className={classnames({
          'no-print': true,
        })}
        style={{
          fontSize: '16px',
          color: '#aaa',
          margin: '-20px 0 5px',
        }}
      >
        {showResults}
      </div>
      <div
        className={classnames({
          'no-print': true,
        })}
        style={{
          borderBottom: '1px solid rgb(200, 200, 200)',
          paddingBottom: '5px',
        }}
      >
        <button
          className="email-results"
          onClick={toggleEmailOverlay}
        >
          Email Results
        </button>
        <button
          className="print-results"
          onClick={() => print()}
        >
          Print Results
        </button>
        <button
          className="clear-results"
          onClick={clearAssessmentResults}
        >
          Clear Results
        </button>
      </div>
      {showNoStrengths &&
        <ResultNoStrengths
          text={fieldNoStrengthsText[0] && fieldNoStrengthsText[0].value}
          title={fieldNoStrengthsTitle[0] && fieldNoStrengthsTitle[0].value}
        />
      }
      <ResultHigh
        highResults={highResults}
        introText={fieldGoodIntroText[0] && fieldGoodIntroText[0].value}
        title={fieldGoodResultsTitle[0] && fieldGoodResultsTitle[0].value}
      />
      {showAllStrengths &&
        <ResultAllStrengths
          text={fieldAllStrengthsText[0] && fieldAllStrengthsText[0].value}
          title={fieldAllStrengthsTitle[0] && fieldAllStrengthsTitle[0].value}
        />
      }
      <ResultMedium
        introText={fieldMediumIntroText[0] && fieldMediumIntroText[0].value}
        mediumResults={mediumResults}
        title={fieldMediumResultsTitle[0] && fieldMediumResultsTitle[0].value}
      />
      <ResultLow
        introText={fieldLowIntroText[0] && fieldLowIntroText[0].value}
        lowResults={lowResults}
        title={fieldLowResultsTitle[0] && fieldLowResultsTitle[0].value}
      />
      <ButtonPrevious
        previousStep={previousStep}
      />
    </div>
  );
}

Result.propTypes = {
  answers: PropTypes.shape({}),
  assessmentData: PropTypes.arrayOf(PropTypes.shape({})),
  clearAssessmentResults: PropTypes.func,
  emailOverlay: PropTypes.bool,
  emailResults: PropTypes.func,
  emailSent: PropTypes.bool,
  previousStep: PropTypes.func,
  questions: PropTypes.arrayOf(PropTypes.shape({})),
  readingListItems: PropTypes.arrayOf(PropTypes.shape({})),
  resultUserEmail: PropTypes.string,
  setResult: PropTypes.func,
  toggleEmailOverlay: PropTypes.func,
};

export default Result;



// WEBPACK FOOTER //
// js/src/assessment/Result.js